import React from 'react';
import ImgBanner from 'assets/images/banner-drlicita.png';
import createTrack from 'services/actions/tracker_actions';
import { Container } from './styles';

const BannerDrlicitaNewPanel = () => {
  return (
    <Container>
      <button
        type="button"
        className="w-100 h-100 border-0"
        onClick={async () => {
          window.open('/dr_licita', '_blank');
          createTrack('Banner - Dr. Licita');
        }}
      >
        <img src={ImgBanner} className="img-banner" alt="banner" />
      </button>
    </Container>
  );
};

export default BannerDrlicitaNewPanel;
